class CommonMethod {

    getFormattedModuleName(moduleName){
        let formattedModuleName = '';
        if(moduleName === 'IM') {
            formattedModuleName = 'Incident';
        } else if(moduleName === 'PM'){
            formattedModuleName = 'Problem';
        } else if(moduleName === 'CM'){
            formattedModuleName = 'Change';
        } else if(moduleName === 'KM'){
            formattedModuleName = 'Knowldge';    
        }

        return formattedModuleName;
    }

    getFormattedGroupList(groupNames){
        let groups = '';
        if(groupNames !== undefined && groupNames !== null){
            if(groupNames.length > 0){
                let groupNamesData = [];
                groupNames.map((eachGroup)=>{
                    groupNamesData.push(eachGroup['groupName']);
                });
                if(groupNamesData.length > 0){
                    groups = groupNamesData.toString();
                } else {
                    groups = 'N/A';
                }
            } else {
                groups = 'N/A';
            }
        } else {
            groups = 'N/A';
        }

        return groups;
    }

    getSuccess(
        addSuccess,
        deleteSuccess,
        updateSuccess,
        addBulkSuccess,
        apiError
    ){
        let isSucess = false;
        if(
            (apiError === false) && 
            (
                (addSuccess === true) ||
                (deleteSuccess === true) ||
                (updateSuccess === true) ||
                (addBulkSuccess === true)
            )
        ){
            isSucess = true;
        }

        return isSucess;
    }

    getPending(
        addPending,
        deletePending,
        updatePending,
        addBulkPening,
        apiError
    ){
        let isPending = false;
        if(
            (apiError === false) && 
            (
                (addPending === true) ||
                (deletePending === true) ||
                (updatePending === true) ||
                (addBulkPening === true)
            )
        ){
            isPending = true;
        }

        return isPending;
    }

    getFormattedAccessControlList(pageAccessControl){
        let pageNames = '';
        if(pageAccessControl !== undefined && pageAccessControl !== null){
            if(pageAccessControl.length > 0){
                let pageAccessControlData = [];
                pageAccessControl.map((eachAccessControl)=>{
                    pageAccessControlData.push(eachAccessControl['pageName']);
                });
                if(pageAccessControlData.length > 0){
                    pageNames = pageAccessControlData.toString();
                } else {
                    pageNames = 'N/A';
                }
            } else {
                pageNames = 'N/A';
            }
        } else {
            pageNames = 'N/A';
        }

        return pageNames;
    }

    getFormattedRoleList(roleNames){
        let roles = '';
        if(roleNames !== undefined && roleNames !== null){
            if(roleNames.length > 0){
                let roleNamesData = [];
                roleNames.map((eachRole)=>{
                    roleNamesData.push(eachRole['roleName']);
                });
                if(roleNamesData.length > 0){
                    roles = roleNamesData.toString();
                } else {
                    roles = 'N/A';
                }
            } else {
                roles = 'N/A';
            }
        } else {
            roles = 'N/A';
        }

        return roles;
    }

    getFormattedGroupList(groupNames){
        let groups = '';
        if(groupNames !== undefined && groupNames !== null){
            if(groupNames.length > 0){
                let groupNamesData = [];
                groupNames.map((eachGroup)=>{
                    groupNamesData.push(eachGroup['groupName']);
                });
                if(groupNamesData.length > 0){
                    groups = groupNamesData.toString();
                } else {
                    groups = 'N/A';
                }
            } else {
                groups = 'N/A';
            }
        } else {
            groups = 'N/A';
        }

        return groups;
    }

    checkPassword(newPassword)
    {
      let retval = false;
      var pattern = new RegExp(/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-zA-Z]).{8,}$/);
      if (pattern.test(newPassword)) {
        retval = true;
      }

      return retval; 
    }

    getCsvFileNameDetails(startDate, endDate){
        if(startDate !== undefined){
            let today = new Date();
            let y = today.getFullYear();
            let m = today.getMonth() + 1;
            let d = today.getDate();
            let h = today.getHours();
            let mi = today.getMinutes();
            let s = today.getSeconds();
    
            return "DataList_"+startDate+"-"+endDate+ "-" + m + "-" + d + "-" + h + "-" + mi + "-" + s;
        } else {
            return "DataList";
        }
       
    }

    getCompleteExportDataDetails(startDate, endDate, incidentData){
        let incidentDetails = [];
        let data = [];
        incidentData.map((eachIncident) => {

            data = [
                {
                    value :(
                        eachIncident.orderid !== null &&
                        eachIncident.orderid !==  ''
                    )? eachIncident.orderid : ''
                },
                {
                    value : (
                        eachIncident.createDate !== null && 
                        eachIncident.createDate !== ''
                    ) ? eachIncident.createDate : ''
                },
                {
                    value : (
                        eachIncident.result !== null && 
                        eachIncident.result !== ''
                    ) ? eachIncident.result : ''
                },

                {
                    value : (
                        eachIncident.callerId !== null && 
                        eachIncident.callerId !== ''
                    ) ? eachIncident.callerId : ''
                },
                {
                    value : (
                        eachIncident.callerIp !== null && 
                        eachIncident.callerIp !== ''
                    ) ? eachIncident.callerIp : ''
                },
                {
                    value : (
                        eachIncident.calledId !== null && 
                        eachIncident.calledId !== ''
                    ) ? eachIncident.calledId : ''
                },
                {
                    value : (
                        eachIncident.calledIp !== null && 
                        eachIncident.calledIp !== ''
                    ) ? eachIncident.calledIp : ''
                },
                {
                    value : (
                        eachIncident.direction !== null && 
                        eachIncident.direction !== ''
                    ) ? eachIncident.direction : '',
                },
                {
                    value : (
                        eachIncident.rtpCallerG107mos !== null && 
                        eachIncident.rtpCallerG107mos !== ''
                    ) ? eachIncident.rtpCallerG107mos : ''
                },
                {
                    value : (
                        eachIncident.rtpCalledG107mos !== null && 
                        eachIncident.rtpCalledG107mos !== ''
                    ) ? eachIncident.rtpCalledG107mos : ''
                },
                {
                    value : (
                        eachIncident.rtpCallG107mosAverage !== null && 
                        eachIncident.rtpCallG107mosAverage!== ''
                    ) ? eachIncident.rtpCallG107mosAverage : ''
                },
                {
                    value : (
                        eachIncident.answeredDuration !== null && 
                        eachIncident.answeredDuration !== ''
                    ) ? eachIncident.answeredDuration : ''
                },
                {
                    value : (
                        eachIncident.disconnectionStatus !== null && 
                        eachIncident.disconnectionStatus !== ''
                    ) ? eachIncident.disconnectionStatus : ''
                },
                {
                    value : (
                        eachIncident.releasedBy !== null && 
                        eachIncident.releasedBy !== ''
                    ) ? eachIncident.releasedBy : '',
                },
                {
                    value : (
                        eachIncident.rtpCodec !== null && 
                        eachIncident.rtpCodec !== ''
                    ) ? eachIncident.rtpCodec : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsTotal !== null && 
                        eachIncident.rtpRxPacketsTotal !== ''
                    ) ? eachIncident.rtpRxPacketsTotal : ''
                },
                 {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedLate !== null && 
                        eachIncident.rtpRxPacketsDiscardedLate !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedLate : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedEarly !== null && 
                        eachIncident.rtpRxPacketsDiscardedEarly !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedEarly : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedDuplicated !== null && 
                        eachIncident.rtpRxPacketsDiscardedDuplicated !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedDuplicated : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedError !== null && 
                        eachIncident.rtpRxPacketsDiscardedError !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedError : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedPercentage !== null && 
                        eachIncident.rtpRxPacketsDiscardedPercentage !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedPercentage : ''
                },
                {
                    value : (
                        eachIncident.rtpCalledMeanrfc3550jitter !== null && 
                        eachIncident.rtpCalledMeanrfc3550jitter !== ''
                    ) ? eachIncident.rtpCalledMeanrfc3550jitter : ''
                },
                {
                    value : (
                        eachIncident.rtpCalledMaxrfc3550jitter !== null && 
                        eachIncident.rtpCalledMaxrfc3550jitter !== ''
                    ) ? eachIncident.rtpCalledMaxrfc3550jitter : ''
                }
            ];
            incidentDetails.push(data);
        });

        let details = [
            {
                columns: [
                    {
                        title: this.getCsvHeadersDetails(startDate, endDate),
                    }
                ],
                data: [],
            },
            {
                columns: this.getCsvColoumnsDetails(),
                data: incidentDetails
            }
        ];

        return details;
    }

    getCsvHeadersDetails(startDate, endDate){
        if(startDate !== undefined){
            return 'Data List ( From date : '+startDate+' TO date : '+endDate+')';
        } else {
            return 'Data List';
        }
    }

    getCsvColoumnsDetails(){
        return  [
            {
                title :"Optus Reference Number",
                width:{wch: 25}
            },
            {
                title: "Date and Time",
                width: {wch: 25}
            },
            {
                title : "Test result",
                width:{wch: 15}
            },
            {
                title: "A Source",
                width: {wch: 15}
            },
            {
                title: "A Source IP",
                width : {wch: 15}
            },
            {
                title: "B Destination",
                width: {wch: 15}
            },
            {
                title: "B Destination IP",
                width : {wch: 25}
            },
            {
                title: "Call Direction",
                width: {wch: 15}
            },
            {
                title:  "MOS A",
                width: {wch: 20}
            },
            {
                title:  "MOS B",
                width: {wch: 20}
            },
            {
                title: "MOS Average",
                width: {wch: 15}
            },
            {
                title: "Call Duration",
                width: {wch: 15}
            },
            {
                title: "Release Cause",
                width: {wch: 15}
            },
            {
                title: "Release Location",
                width: {wch: 20}
            },
            {
                title: "Voice Codec", 
                width: {wch: 15}
            },
            {
                title:  "Total Packets",
                width: {wch: 15}
            },
            {
                title: "Late Packets",
                width: {wch: 15}
            },
            {
                title: "Early Packets",
                width: {wch: 15}
            },
            {
                title:"Overlapping Packets",
                width: {wch: 25}
            },
            {
                title: "Packet Errors",
                width: {wch: 15}
            },
            {
                title: "Discarded Packets",
                width: {wch: 25}
            },
            {
                title: "Average Jitter",
                width: {wch: 20}
            },
            {
                title: "Max Jitter",
                width: {wch: 20}
            },

        ];
    }

    getDataAfterCheckBoxCheckDetails(startDate, endDate, incidentData){
        let checkedIncident = Object.values(incidentData);
        let incidentDetails = [];
        let data = [];
        checkedIncident.map((eachIncident) => {

            data = [
                {
                    value :(
                        eachIncident.orderid !== null &&
                        eachIncident.orderid !==  ''
                    )? eachIncident.orderid : ''
                },
                {
                    value : (
                        eachIncident.createDate !== null && 
                        eachIncident.createDate !== ''
                    ) ? eachIncident.createDate : ''
                },
                {
                    value : (
                        eachIncident.result !== null && 
                        eachIncident.result !== ''
                    ) ? eachIncident.result : ''
                },

                {
                    value : (
                        eachIncident.callerId !== null && 
                        eachIncident.callerId !== ''
                    ) ? eachIncident.callerId : ''
                },
                {
                    value : (
                        eachIncident.callerIp !== null && 
                        eachIncident.callerIp !== ''
                    ) ? eachIncident.callerIp : ''
                },
                {
                    value : (
                        eachIncident.calledId !== null && 
                        eachIncident.calledId !== ''
                    ) ? eachIncident.calledId : ''
                },
                {
                    value : (
                        eachIncident.calledIp !== null && 
                        eachIncident.calledIp !== ''
                    ) ? eachIncident.calledIp : ''
                },
                {
                    value : (
                        eachIncident.direction !== null && 
                        eachIncident.direction !== ''
                    ) ? eachIncident.direction : '',
                },
                {
                    value : (
                        eachIncident.rtpCallerG107mos !== null && 
                        eachIncident.rtpCallerG107mos !== ''
                    ) ? eachIncident.rtpCallerG107mos : ''
                },
                {
                    value : (
                        eachIncident.rtpCalledG107mos !== null && 
                        eachIncident.rtpCalledG107mos !== ''
                    ) ? eachIncident.rtpCalledG107mos : ''
                },
                {
                    value : (
                        eachIncident.rtpCallG107mosAverage !== null && 
                        eachIncident.rtpCallG107mosAverage!== ''
                    ) ? eachIncident.rtpCallG107mosAverage : ''
                },
                {
                    value : (
                        eachIncident.answeredDuration !== null && 
                        eachIncident.answeredDuration !== ''
                    ) ? eachIncident.answeredDuration : ''
                },
                {
                    value : (
                        eachIncident.disconnectionStatus !== null && 
                        eachIncident.disconnectionStatus !== ''
                    ) ? eachIncident.disconnectionStatus : ''
                },
                {
                    value : (
                        eachIncident.releasedBy !== null && 
                        eachIncident.releasedBy !== ''
                    ) ? eachIncident.releasedBy : '',
                },
                {
                    value : (
                        eachIncident.rtpCodec !== null && 
                        eachIncident.rtpCodec !== ''
                    ) ? eachIncident.rtpCodec : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsTotal !== null && 
                        eachIncident.rtpRxPacketsTotal !== ''
                    ) ? eachIncident.rtpRxPacketsTotal : ''
                },
                 {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedLate !== null && 
                        eachIncident.rtpRxPacketsDiscardedLate !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedLate : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedEarly !== null && 
                        eachIncident.rtpRxPacketsDiscardedEarly !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedEarly : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedDuplicated !== null && 
                        eachIncident.rtpRxPacketsDiscardedDuplicated !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedDuplicated : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedError !== null && 
                        eachIncident.rtpRxPacketsDiscardedError !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedError : ''
                },
                {
                    value : (
                        eachIncident.rtpRxPacketsDiscardedPercentage !== null && 
                        eachIncident.rtpRxPacketsDiscardedPercentage !== ''
                    ) ? eachIncident.rtpRxPacketsDiscardedPercentage : ''
                },
                {
                    value : (
                        eachIncident.rtpCalledMeanrfc3550jitter !== null && 
                        eachIncident.rtpCalledMeanrfc3550jitter !== ''
                    ) ? eachIncident.rtpCalledMeanrfc3550jitter : ''
                },
                {
                    value : (
                        eachIncident.rtpCalledMaxrfc3550jitter !== null && 
                        eachIncident.rtpCalledMaxrfc3550jitter !== ''
                    ) ? eachIncident.rtpCalledMaxrfc3550jitter : ''
                }
            ];
            incidentDetails.push(data);
        });

        let details = [
            {
                columns: [
                    {
                        title: this.getCsvHeadersDetails(startDate, endDate),
                    }
                ],
                data: [],
            },
            {
                columns: this.getCsvColoumnsDetails(),
                data: incidentDetails
            }
        ];

        return details;
    }
}

const CommonMethods = new CommonMethod();

export { CommonMethods };
